import { render, staticRenderFns } from "./ReleasesSlider.vue?vue&type=template&id=a718d958&"
import script from "./ReleasesSlider.vue?vue&type=script&lang=js&"
export * from "./ReleasesSlider.vue?vue&type=script&lang=js&"
import style0 from "./ReleasesSlider.vue?vue&type=style&index=0&id=a718d958&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports